var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPointPlusnosvgo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.72,3.36L15.28,3.36L15.28,8.72L20.64,8.72L20.64,15.28L15.28,15.28L15.28,20.64L8.72,20.64L8.72,15.28L3.36,15.28L3.36,8.72L8.72,8.72Z",
  fill: "currentColor"
})));
export default SvgPointPlusnosvgo;